<cc-input-error *ngIf="error"
                [form]="form"
                [inputName]="inputName"
                [error]="error.error"
                [text]="error.text"></cc-input-error>
